import { Box, Flex, FlexProps, Text } from '@cmpsr/components';
import DecreasedRiskBadge from '../badges/decreased-risk-badge';
import IncreasedRiskBadge from '../badges/increased-risk-badge';
import RiskAssessmentCompletedBadge from '../badges/risk-assessment-completed-badge';
import { formatRiskDecimal } from '@/utils';

export type RiskTrendCardData = {
  riskChange: number;
  label: string;
  calculatedAt?: string;
  isRiskAssessmentCompleted?: boolean;
};

type RiskTrendCardProps = FlexProps & {
  trend: RiskTrendCardData;
  trendIndex?: number;
  totalTrendCount?: number;
  areAllTrendsLoaded?: boolean;
};

export default function RiskTrendCard({
  trend,
  trendIndex,
  totalTrendCount,
  areAllTrendsLoaded,
  ...props
}: RiskTrendCardProps) {
  const { riskChange, label, calculatedAt } = trend;
  const formattedRiskChange = riskChange < 0 ? Math.abs(riskChange) : riskChange;
  const isRiskAssessmentCompletedTrend = trend.isRiskAssessmentCompleted;

  return (
    <Flex gap="spacer-4" alignItems="center" {...props}>
      <Box w="60px">
        {isRiskAssessmentCompletedTrend ? (
          <RiskAssessmentCompletedBadge percentage={formatRiskDecimal(riskChange)} />
        ) : riskChange > 0 ? (
          <IncreasedRiskBadge percentage={formatRiskDecimal(riskChange)} />
        ) : riskChange < 0 ? (
          <DecreasedRiskBadge percentage={formatRiskDecimal(formattedRiskChange)} />
        ) : null}
      </Box>
      <Flex flexDirection="column" flex="1">
        <Text variant="text-body-floating-label-regular" color="text-secondary">
          {calculatedAt}
        </Text>
        <Text variant="text-body-meta-regular">{label}</Text>
      </Flex>
    </Flex>
  );
}
